var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.75C7.2125 10.75 7.39075 10.678 7.53475 10.534C7.67875 10.39 7.7505 10.212 7.75 10C7.75 9.7875 7.678 9.6095 7.534 9.466C7.39 9.3225 7.212 9.2505 7 9.25C6.7875 9.25 6.6095 9.322 6.466 9.466C6.3225 9.61 6.2505 9.788 6.25 10C6.25 10.2125 6.322 10.3907 6.466 10.5347C6.61 10.6787 6.788 10.7505 7 10.75ZM6.25 7.75H7.75V3.25H6.25V7.75ZM4.1875 13.75L0.25 9.8125V4.1875L4.1875 0.25H9.8125L13.75 4.1875V9.8125L9.8125 13.75H4.1875Z",
    fill: "#FB7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.1225bbe927c4ef16bcc4384f9391971f.svg";
export { ForwardRef as ReactComponent };